import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectTypeSupportedIntentsComponent } from './project-type-supported-intents.component';
import {
  NbCardModule,
  NbDialogModule,
  NbDialogService,
  NbSpinnerModule,
} from '@nebular/theme';
import { ComponentsModule } from '../components.module';

@NgModule({
  declarations: [ProjectTypeSupportedIntentsComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    NbCardModule,
    NbSpinnerModule,
    NbDialogModule,
  ],
  exports: [ProjectTypeSupportedIntentsComponent],
})
export class ProjectTypeSupportedIntentsModule {}
